// extracted by mini-css-extract-plugin
export default {"status":"deviceProgressStatus_status__LU5oi"};